module.exports = __webpack_public_path__ + "static/media/side-looker.054ece48.png";